export class Mapping {
  id: string;
  platform: string;
}

export class Translation {
  name: string;
  lang: string;
  description: string;
}

export class Price {
  price: number;
  currency: string;
  pricelist: string;
}

export class ApiProduct {
  code: string;
  productCode: string;
  variantLabels: string[];
  defaultVariantId: Mapping;
  defaultVariantName: Translation;
  defaultProductName: Translation;
  defaultPrice: Price;
  productLabels: string[];
}

export class Currencies {
  public static values = ['eur', 'pln', 'usd', 'gbp', 'jpy'];
}

// product variant
export class VariantBase {
  code: string;
}

export class PriceCurrency {
  value: number;
  currency: string;
}

export class PriceList {
  name: String;
}

export class PriceListPrice extends PriceCurrency {
  priceList: PriceList;
}

export class VariantPrice<V extends VariantBase> extends PriceListPrice {
  variant: V;
}

export class TransactionEntryBase<V extends VariantBase, P extends VariantPrice<V>> {
  quantity: number;
  price: P;
}

export class TransactionBase<E extends TransactionEntryBase<any, any>> {
  entries: Array<E>;
}

export class SimpleOrderEntryMetadata {
  quantityAdjustable: boolean;
}

export class SimpleOrderEntry extends TransactionEntryBase<VariantBase, VariantPrice<VariantBase>> {
  metadata: SimpleOrderEntryMetadata;
}

export class SimpleOrder extends TransactionBase<SimpleOrderEntry> {}

